<script>
  import { apiFetch } from "../../lib/api.js";
  import { user } from "../../stores/user"
  import CardContent from "../CardContent.svelte"
  import Alert from "../../components/Alert.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"

  export let id = 0
  export let id_cliente = 0
  export let nombres = ""
  export let razon_social
  export let clientes = []

  let isSeting = false

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 3000,
  }

  let new_razon_social = ""

  const handleMover = async () => {
    isSeting = true
    const formData = new FormData()
    formData.append("id_usuario", id)
    formData.append("id_cliente", id_cliente)
    formData.append("razon_social", razon_social)
    formData.append("nombres", nombres)
    formData.append("new_razon_social", new_razon_social)
    formData.append("action", "moveUsuario")
    formData.append("session_id_usuario", $user.idUsuario)
    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    })
    const resp = await response.json()
    if (resp.status == "success") {
      alert.show = true
      alert.message = "Datos actualizados"
      alert.status = "success"
      razon_social = new_razon_social
    } else {
      alert.show = true
      alert.message = "Error al actualizar los datos"
      alert.status = "danger"
    }
    isSeting = false
  }

  const changeCliente = () => {
    new_razon_social = razonSocialById(id_cliente)
    console.log(new_razon_social)
  }

  function razonSocialById(id) {
    const cliente_encontrado = clientes.find((c) => c.id == id)
    if (cliente_encontrado) {
      return cliente_encontrado.razon_social
    } else {
      return "Cliente no encontrado"
    }
  }
</script>

{#if $user}
  <CardContent title="Mover usuario">
    <div class="row mb-2 g-2">
      <div class="col-12 col-lg-4">
        <label for="usuario">Usuario</label>
      </div>
      <div class="col-12 col-lg-8">
        <input type="text" class="form-control" bind:value={nombres} disabled />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-lg-4">
        <label for="razon_social">Cliente</label>
      </div>
      <div class="col-12 col-lg-8">
        <input
          type="text"
          class="form-control"
          bind:value={razon_social}
          disabled
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-lg-4">
        <label for="cliente">Mover al cliente</label>
      </div>
      <div class="col-12 col-lg-8">
        <select
          class="form-select"
          bind:value={id_cliente}
          on:change={changeCliente}
        >
          <option value="0">SELECCIONE UN CLIENTE</option>
          {#each clientes as cliente}
            <option value={cliente.id}>{cliente.razon_social}</option>
          {/each}
        </select>
      </div>
    </div>

    <div class="text-end mb-2">
      {#if isSeting}
        <button class="btn btn-primary" disabled>Moviendo...</button>
      {:else}
        <button class="btn btn-primary" on:click={handleMover}>Mover</button>
      {/if}
    </div>

    {#if alert.show}
      <Alert message={alert.message} status={alert.status} time={alert.time} />
    {/if}
  </CardContent>
{/if}
